<div class="container" *ngIf="post">
    <div class="page-header page-produit position-relative text-center px-5 mt-5">

        <div class="returnButton font-weight-bold" *ngIf="isRd && !isInterview" [routerLink]="language.navigateAccordingToLang(['/research-innovation'])"><i class="fa fa-chevron-left returnIcon mr-2" aria-hidden="true" title="Immersive Factory: R&D departments"></i>{{'Retour' | translate}}</div>
        <div class="returnButton font-weight-bold" *ngIf="!isRd && !isInterview" [routerLink]="language.navigateAccordingToLang(['/blog'])"><i class="fa fa-chevron-left returnIcon mr-2" aria-hidden="true" title="blog"></i>{{'Retour' | translate}}</div>
        <div class="returnButton font-weight-bold" *ngIf="!isRd && isInterview" [routerLink]="language.navigateAccordingToLang(['/interviews'])"><i class="fa fa-chevron-left returnIcon mr-2" aria-hidden="true" title="blog"></i>{{'Retour' | translate}}</div>
        <ul class="mots-cles d-flex justify-content-center" *ngIf="!isRd && !isInterview">
            <li>{{post['tag']['title']}}</li>
        </ul>
        <h1 class="py-2 px-5" id="postTitle">{{ post['title'] }}</h1>
        <!-- <p class="lead text-muted" style="font-size:15px;">{{'Posté le' | translate}} {{language.getDate(post['createdDate'])}}</p> -->
    </div>

    <div class="row mb-5 mt-4">
        <div class="col-lg-12">
            <div *ngIf="!post['ytId'] && post['imageHeader']" class="imgHeader rounded" [ngStyle]="{'background-image' : 'url('+post['img']+')'}"></div>
            <div *ngIf="post['ytId']" class="ytVideo rounded">
                <iframe [src]="post['ytLink']" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </div>
        </div>
      </div>
      <div class="row my-5 pb-3">
        <div class="col-lg-4">
            <div class="sticky-left">
                <div class="bg-light rounded summary">
                  <div class="dark-blue text-center">
                    <i class="fas fa-list mr-2"></i>{{'Sommaire' | translate}}
                  </div>
                  <div class="summary-content m-0 p-0">
                    <a *ngFor="let heading of headings" (click)="goTo(heading.id)" class="position-relative d-inline-block w-100" [ngClass]="{'active' : heading.id == checkActive, 'heading2' : heading.level==2, 'heading3' : heading.level==3}">
                        <div class="titles" [ngClass]="{'heading2' : heading.level==2, 'heading3' : heading.level==3}">{{ heading.text }}</div>
                    </a>
                  </div>
                </div>
                <div class="encart mt-4">
                  <div class="bg-light rounded text-center p-4">
                      <p class="mb-0 pb-0">{{'Envie d’en savoir plus ?' | translate}}</p>
                      <button class="mt-3 btn btn-immersive btn-rounded px-5" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
                  </div>
                </div>
            </div>
        </div>
        <div class="col-lg-8 mb-5 mb-lg-0 mt-5 mt-lg-0 article-content">
            <div id="postContent" class="text mb-4" [innerHTML]="((post['htmlContent']) ? post['htmlContent'] : '...')"></div>
            <div class="d-flex align-items-center flex-wrap justify-content-between">
                <div class="social-share mr-4">
                    <a class="facebook" title="Facebook" target="_blank" rel="noopener nofollow" href="{{share('fb')}}" title="facebook"><i class="fa fa-facebook"></i></a>
                    <a class="twitter" title="Twitter" target="_blank" rel="noopener nofollow" href="{{share('tw')}}" title="twitter"><i class="fa fa-twitter"></i></a>
                    <a class="linkedin" title="LinkedIn" target="_blank" rel="noopener nofollow" href="{{share('li')}}" title="linkedin"><i class="fa fa-linkedin"></i></a>
                    <a class="mail" title="{{'Mail' | translate}}" (click)="share('mail')" ><i class="fa fa-envelope"></i></a>
                    <a class="print" title="{{'Imprimer' | translate}}" (click)="share('print')"><i class="fa fa-print"></i></a>
                </div>
            </div>
            <ng-container *ngIf="author">
                <hr class="mb-4">
                <div class="author-account">
                    <div class=" d-flex gap-4">
                        <div class="flex-shrink-0">
                            <img [src]="author.image" width="50" class="rounded-pill" alt="Aurélie">
                        </div>
                        <div>
                            <div class="author-name">{{'Écrit par' | translate}} {{author.name}}</div>
                            <div class="author-job">{{author.job[language.lang]}}</div>
                            <div class="author-desc">{{author.description[language.lang]}}</div>
                        </div>
                    </div>
    
                </div>
            </ng-container>



        </div>

        <!-- <div class="col-lg-4">
            <div class="row">
                <div class="col-12">
                    <div class="bg-light p-4 lastArticles rounded">
                        <h2 *ngIf="!isRd">{{'Dernières actualités' | translate}}</h2>
                        <h2 *ngIf="isRd">{{'Derniers articles R&D' | translate}}</h2>
                        <a class="lastArticle" *ngFor="let lastPost of lastPosts" [routerLink]="language.navigateAccordingToLang([lastPost.link])" title="{{lastPost.title}}">
                            <div class="title">{{lastPost.title}}</div>
                            <div class="date text-muted">{{'Posté le' | translate}} {{language.getDate(lastPost['createdDate'])}}</div>
                        </a>
                    </div>
                </div>
            </div>
        </div> -->

    </div>
</div>
<div class="light-grey mt-5 relatedNews">
  <div class="container">
    <div class="row pt-5 pb-3 p-3 d-flex align-items-center justify-content-between">
      <h3 class="text-left mb-3 mb-md-0" *ngIf="sameCatNews.length && !isRd && !isInterview">{{'Autres articles dans la catégorie' | translate}} "{{post.tag['title']}}"</h3>
      <h3 class="text-left mb-3 mb-md-0" *ngIf="sameCatNews.length && !isRd && isInterview">{{'Autres interviews' | translate}}</h3>
      <button class="btn btn-immersive btn-rounded px-5" *ngIf="!isRd && !isInterview" [routerLink]="language.navigateAccordingToLang(['/blog'])">{{'Voir tous les articles' | translate}}<i class="fas fa-long-arrow-alt-right ml-2"></i></button>
      <button class="btn btn-immersive btn-rounded px-5" *ngIf="!isRd && isInterview" [routerLink]="language.navigateAccordingToLang(['/interviews'])">{{'Voir toutes les interviews' | translate}}<i class="fas fa-long-arrow-alt-right ml-2"></i></button>
    </div>
    <div class="row">
      <div class="d-flex flex-column flex-md-row justify-content-center mb-5" *ngIf="!isRd">
          <div class="col-md-4 my-4" *ngFor="let actu of sameCatNews">
              <app-actualite-card [postInfos]="actu" [isRd]="isRd" [isInterview]="isInterview"></app-actualite-card>
          </div>
      </div>
    </div>
  </div>
</div>
